<template>
  <div>
    <b-tabs
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- billing information settings tab -->
      <b-tab>

        <!-- title -->
        <template #title>
          <span class="font-weight-bold">
            {{ $t('settings.billing-information.title') }}
          </span>
        </template>

        <billing-information-settings-tab />
      </b-tab>
      <!--/ billing information settings tab -->

      <!-- invoices settings tab -->
      <b-tab>

        <!-- title -->
        <template #title>
          <span class="font-weight-bold">
            {{ $t('settings.invoices.title') }}
          </span>
        </template>

        <invoices-settings-tab />
      </b-tab>
      <!--/ invoices settings tab -->

      <!-- plan settings tab -->
      <b-tab @click="openStripePortal">

        <!-- title -->
        <template #title>
          <span class="font-weight-bold d-flex align-items-center">
            {{ $t('settings.subscription.title') }}
            <feather-icon
              size="12"
              icon="ExternalLinkIcon"
              class="ml-50"
            />
          </span>
        </template>

        <subscription-tab :open-portal-fn="openStripePortal" />
      </b-tab>
      <!--/ plan settings tab -->
    </b-tabs>
  </div>
</template>

<script>
import planAndBillingSetup from '@/views/organization/settings/plan-and-billing/planAndBillingSetup'
import BillingInformationSettingsTab
from '@/views/organization/settings/plan-and-billing/tabs/BillingInformationSettingsTab'
import InvoicesSettingsTab from '@/views/organization/settings/plan-and-billing/tabs/InvoicesSettingsTab'
import SubscriptionTab from '@/views/organization/settings/plan-and-billing/tabs/SubscriptionTab.vue'

export default {
  components: { SubscriptionTab, InvoicesSettingsTab, BillingInformationSettingsTab },
  setup: planAndBillingSetup,
}
</script>

<style scoped>

</style>
